export const iconFontAwesomeMoneyRupiahSign = (
	<i className="fa-solid fa-rupiah-sign"></i>
);
